import { constants } from "@thecb/components";

const { CHARADE_GREY, ROYAL_BLUE_VIVID } = constants.colors;

export const fallbackValues = {
  primaryColor: ROYAL_BLUE_VIVID,
  secondaryColor: CHARADE_GREY
};
